// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e52e3bd","455":"c1d76c4e"}[chunkId] + ".chunk.js";
};